import http from "../axios/http-common";

class InterfaceSKDP {
  getSKDP(reg) {
    return http.getData(`/register/${reg}/skdp`);
  }

  getSKDPByID(id) {
    return http.getData(`/skdp/${id}`);
  }

  saveTtdSKDP(id, user_id, password) {
    // return http.postData(`/skdp/${id}/signature`, {
    return http.postData(`/skdp/${id}/signature`, {
      user_id: user_id,
      password: password
    });
  }

  saveSKDP(
    reg,
    dpjp_id,
    unit_id,
    tgl_rujukan,
    diagnosis,
    alasan,
    rtl,
    tgl_kunjungan,
    user_id,
    kronis
  ) {
    return http.postData(`/skdp`, {
      register_id: reg,
      dpjp_id: dpjp_id,
      unit_id: unit_id,
      tgl_rujukan: tgl_rujukan,
      diagnosis: diagnosis,
      alasan: alasan,
      rtl: rtl,
      tgl_kunjungan: tgl_kunjungan,
      user_id: user_id,
      kasus_kronis: kronis
    });
  }

  changeSKDP(
    id,
    reg,
    dpjp_id,
    unit_id,
    tgl_rujukan,
    diagnosis,
    alasan,
    rtl,
    tgl_kunjungan,
    user_id,
    kronis
  ) {
    return http.putData(`/skdp/${id}`, {
      register_id: reg,
      dpjp_id: dpjp_id,
      unit_id: unit_id,
      tgl_rujukan: tgl_rujukan,
      diagnosis: diagnosis,
      alasan: alasan,
      rtl: rtl,
      tgl_kunjungan: tgl_kunjungan,
      user_id: user_id,
      kasus_kronis: kronis
    });
  }

  getAlasan(term) {
    return http.getDataParam(`/template-text/alasan-skdp`, {
      params: {
        term: term
      }
    });
  }

  getRtl(term) {
    return http.getDataParam(`/template-text/rtl-skdp`, {
      params: {
        term: term
      }
    });
  }

  getKontrolSkdpAlert(param) {
    return http.getData(
      `/skdp/cek-kuota-kontrol/tgl/${param.tgl}/unit/${param.unit_id}/dokter/${param.dr_id}`
    );
  }

  getKuotaMjkn(param) {
    return http.getData(
      `/skdp/kuota-mjkn/unit/${param.unit_id}/dokter/${param.dr_id}/from/${param.from}/to/${param.to}`
    );
  }
}
export default new InterfaceSKDP();
